import { useMemo } from "react"

import { useSharedRoomPriceQuery } from "shared/api/price/queries.generated"

import { AggregatedRoomData } from "../types/AggregatedRoom"
import {
  AggregatedRoomDataOptions,
  useAggregatedRoomData
} from "./useAggregatedRoomData"

export function useAggregatedSharedRoomData({
  roomID,
  projectID,
  options
}: {
  roomID: string
  projectID: string
  options?: AggregatedRoomDataOptions
}): AggregatedRoomData {
  const baseData = useAggregatedRoomData({ roomID, projectID })

  const {
    data: priceData,
    loading: isLoadingPrice,
    error: priceError
  } = useSharedRoomPriceQuery({
    variables: { projectShareID: projectID, roomID },
    skip: !options?.includePrice || !projectID || baseData.meta.isPending
  })

  const sharedRoomPrice = priceData?.sharedRoomPrice ?? null
  const price = useMemo(
    () =>
      options?.includePrice
        ? {
            data: sharedRoomPrice,
            isLoading:
              isLoadingPrice || (!priceError && !sharedRoomPrice?.isValid),
            error: !!priceError
          }
        : null,
    [options?.includePrice, sharedRoomPrice, isLoadingPrice, priceError]
  )

  return { ...baseData, price }
}
